import { FormFieldWidget, ModelFieldType, SPI, ViewType, Widget } from '@kunlun/dependencies';
import PartialCancellation from './PartialCancellation.vue';
import { CallChaining } from '@kunlun/vue-ui-antd';
import { queryCancelReasonApi } from './api';
import { cloneDeep } from 'lodash-es';

@SPI.ClassFactory(
  FormFieldWidget.Token({
    viewType: ViewType.Form,
    ttype: ModelFieldType.String,
    widget: 'PartialCancellation',
    multi: false
  })
)
export class FormStringPartialCancellationFieldWidget extends FormFieldWidget {
  public initialize(props) {
    super.initialize(props);
    this.setComponent(PartialCancellation);
    return this;
  }

  @Widget.Reactive()
  viewCreateOrderSaleSkuList: any[] = [];
  @Widget.Reactive()
  itemCheckedStatusArr: boolean[]|[] = [];

  @Widget.Reactive()
  public _data: {
    cancelReasonList: {
      id: any;
      cancelReason: any;
    }[];
  } = {
    cancelReasonList: []
  };

  @Widget.Reactive()
  @Widget.Inject()
  protected mountedCallChaining: CallChaining | undefined;

  protected mounted() {
    super.mounted();
    if (this.mountedCallChaining) {
      this.mountedCallChaining.hook(this.path, async () => {
        await this.mountedProcess();
      });
    } else {
      this.mountedProcess();
    }
  }

  @Widget.Method()
  public async mountedProcess() {
    this.queryCancelReason();
    this.viewCreateOrderSaleSkuList = cloneDeep(this.formData.createOrderSaleSkuList as any[]);
    this.mountedProcessSignal = true;
    this.itemCheckedStatusArr = Array(this.viewCreateOrderSaleSkuList.length).fill(true);  

    
  }
  // @Widget.Method()
  // changeItemChecked(i: number) {
  //   try {
  //     this.itemCheckedStatusArr[i] = false
  //     console.log(this.itemCheckedStatusArr[i]);
  //     console.log(!this.itemCheckedStatusArr[i]);
  //   } catch (error) {
  //     console.log(error);
      
  //   }
    
  // }
  private async queryCancelReason() {
    const resData = await queryCancelReasonApi();
    this._data.cancelReasonList = (resData.content as any[]) ?? [];
  }

  @Widget.Reactive()
  private mountedProcessSignal = false;
}
